import {
    UPDATE_UTILISATEUR_PASSWORD_REQUEST,
    UPDATE_UTILISATEUR_PASSWORD_SUCCESS,
    UPDATE_UTILISATEUR_PASSWORD_FAILURE,
  } from "../Types";
  
  const initialState = {
    loading: false,
    error: null,
    message: null, 
  };
  
  const UpdateUtilisateurPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_UTILISATEUR_PASSWORD_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          message: null,
        };
  
      case UPDATE_UTILISATEUR_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          message: action.payload.message || "Mot de passe mis à jour avec succès",
        };
  
      case UPDATE_UTILISATEUR_PASSWORD_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default UpdateUtilisateurPasswordReducer;
  